<template>

    <!--==================================================
                        ARTICLE
        ==================================================-->

    <main id="article-not-found" v-if="!fullContent">
        <div class="container">

            <!-- <svg class="article-not-found__icon" viewBox="0 0 128 128" role="img" aria-labelledby="article-not-found-title">
                <title id="article-not-found-title">{{ 'Not found' | i }}</title>
                <circle cx="64" cy="64" r="48" fill="none" stroke="currentColor" stroke-width="6" />
                <path d="M42 48h.01M86 48h.01M43 82c12-12 30-12 42 0" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="6" />
            </svg> -->

            <svg class="article-not-found__code" viewBox="0 0 180 64" role="img" aria-label="404">
                <text x="90" y="48" text-anchor="middle" fill="currentColor" font-size="48" font-weight="700" font-family="Arial, sans-serif">404</text>
            </svg>

            
            
            <h1>{{ 'Not found' | i }}</h1>
            <p>{{ 'The article or page you are looking for could not be found.' | i }}</p>
        </div>
    </main> 

    <main id="article" class="article" v-else>

        <!-- Hero -->

        <section class="article__hero">
            <div class="article__hero-logo">

                <img :src="'logo1.webp' | assetsImg" alt="BridgeRocks">

            </div>

            <img class="article__hero-bg" :src="'ejemplo8.webp' | assetsImg">

            <div class="article__overlay"></div>

            <div class="container">

                <div class="article__hero-content">

                    <span class="article__category">

                        {{ this.$route.name | i }}

                    </span>

                    <h1 class="article__title">

                        {{ this.fullContent.title }}

                    </h1>

                    <div class="article__meta" v-if="displayBlogInfo">

                        <span class="upper-case">

                            {{ this.fullContent.modified | humanize }}

                        </span>

                        <span>

                            •

                        </span>

                        <span>

                            By Bridgerocks Editorial

                        </span>

                        <span>

                            •

                        </span>

                        <!-- <span> -->

                        <small>({{ readingTime }} {{ 'min_read' | i }})</small>

                        <!-- </span> -->

                    </div>
                    <div class="article__meta" v-else>

                        <span class="upper-case">

                            {{ this.fullContent.modified | humanize }}

                        </span>

                        <!-- <span> -->

                        <small>({{ readingTime }} {{ 'min_read' | i }})</small>

                        <!-- </span> -->

                    </div>

                </div>

            </div>

        </section>

        <!--==================================================
                        ARTICLE BODY
            ==================================================-->

        <section class="article__content">

            <div class="container">

                <div class="article__wrapper">

                    <vue-marked>{{ this.fullContent.content }}</vue-marked>

                </div>

            </div>

        </section>

        <!--==================================================
                        RELATED ARTICLES
            ==================================================-->

        <section class="related" v-if="displayRelated">

            <div class="container">

                <div class="related__header">

                    <span class="section-subtitle">

                        MORE INSIGHTS

                    </span>

                    <h2 class="section-title">

                        Related Articles

                    </h2>

                </div>

                <div class="related__grid">

                    <article class="related__card">

                        <img :src="'ejemplo4.webp' | assetsImg">

                        <span>

                            July 10, 2026

                        </span>

                        <h3>

                            Innovation Through Private Investment

                        </h3>

                        <a href="#">

                            {{ 'Read Article' | i }} →

                        </a>

                    </article>

                    <article class="related__card">

                        <img :src="'ejemplo5.webp' | assetsImg">

                        <span>

                            July 03, 2026

                        </span>

                        <h3>

                            Strategic Partnerships for Global Growth

                        </h3>

                        <a href="#">

                            {{ 'Read Article' | i }} →

                        </a>

                    </article>

                    <article class="related__card">

                        <img :src="'ejemplo2.webp' | assetsImg">

                        <span>

                            June 27, 2026

                        </span>

                        <h3>

                            Why Vision Creates Long-Term Value

                        </h3>

                        <a href="#">

                            {{ 'Read Article' | i }} →

                        </a>

                    </article>

                </div>

            </div>

        </section>

        <div class="debug" v-if="debug">
            <pre>{{ fullContent }}</pre>
        </div>

    </main>

</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';

export default {
    name: 'Article',
    props: {
        debug: {
            type: Boolean,
            default: false
        },
        displayBlogInfo: {
            type: Boolean,
            default: false
        },
        displayRelated: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters(['catalogPagesContent']),
        readingTime() {
            const content = String(this.fullContent?.content || '')
                .replace(/<[^>]*>/g, ' ')
                .replace(/[#*_`~\[\]()]/g, ' ')
                .trim();
            const wordCount = content ? content.split(/\s+/).length : 0;

            return Math.max(1, Math.ceil(wordCount / 200));
        }
    },
    data: () => {
        return {
            fullContent: null
        }
    },
    methods: {
        routeUpdate() {
            try {
                this.fullContent = this.reviewContent();
                if (!this.fullContent)
                    throw new Error('Content not found for slug: ' + this.$route.params.slug);

            } catch (error) {
                console.error('Error reviewing content:', error);
                // this.$router.replace({ name: 'NotFound' });
            } finally {
                document.title = 'Bridgerocks | ' + (this.fullContent?.title || this.$route.params.slug || 'Page');
            }
        },
        reviewContent() {
            const slug = String(this.$route.params.slug || '').trim().toLowerCase();
            return Array.isArray(this.catalogPagesContent)
                ? this.catalogPagesContent.find(content =>
                    String(content.hash || '').trim().toLowerCase() === slug
                )
                : undefined;
        }
    },
    mounted() {
        if (window.mainUI && typeof window.mainUI === 'function')
            setTimeout(window.mainUI, 150);
    },
    watch: {
        '$route.params.slug'() {
            this.routeUpdate()
        }
    },
    beforeMount() {
        this.routeUpdate()
    }
};
</script>

<style lang="scss" scoped>
#article-not-found {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80vh;
    text-align: center;
    .article-not-found__code,
    .article-not-found__icon {
        width: 40vw;
        max-width: 340px;
    }
    p {
        font-size: 1.2rem;
        color: #666;
        max-width: 400px;
        margin: 0 auto;
    }
}
.article__hero::before {
    background: linear-gradient(to bottom,
            hsla(0, 0%, 0%, 0.9),
            hsla(0, 0%, 0%, 0.7) 25%,
            hsla(0, 0%, 0%, 0.25));

}
</style>